export class InvoiceDueInformation {
  isOverdue: boolean;
  displayStatus: string;
  invoiceDueDate: string;

  constructor(isOverdue: boolean, daysUntilDue: string, dueDate: string) {
    this.isOverdue = isOverdue;
    this.displayStatus = daysUntilDue;
    this.invoiceDueDate = dueDate;
  }
}
